import React, { useState } from "react";
import { FormControl, FormGroup, HelpBlock } from "react-bootstrap";
import Select from "react-select";
import ConfirmDeletion from "./ConfirmDeletion";
import DeleteOrderUnitIcon from "./DeleteOrderUnitIcon";

/*
  While the feature is called 'freeProducts', it is actually about free order-units.
  A better naming would be discount-in-kind (German: Naturalrabatt). Originally, we thought
  that Startups would end up giving free products as discount-in-kind. In reality, what happened
  is that they need to be able to give complete OrderUnits as discount-in-kind.
  The naming in the code wasn't fully updated to accomodate that, only the user-facing string.
*/
export const FreeProductSelector = React.forwardRef(
  ({ onChange, value, removeProduct, products, error }, ref) => {
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    return (
      <div className="order-unit-selector form-wrapper">
        {!showDeleteConfirmation && (
          <DeleteOrderUnitIcon
            onClick={() => setShowDeleteConfirmation(true)}
            tooltipText="Bestelleinheit entfernen"
            className="delete-icon"
          />
        )}
        <FormGroup
          className="dropdown-selector"
          validationState={error ? "error" : null}
        >
          <div className="order-unit-name-input">
            <Select
              innerRef={ref}
              options={products}
              placeholder="Name der Bestelleinheit"
              value={value?.orderUnit}
              getOptionLabel={o => o.name}
              getOptionValue={o => o.id}
              onChange={newValue => onChange({ ...value, orderUnit: newValue })}
              noOptionsMessage={() => "Keine aktiven Bestelleinheiten gefunden"}
            />
          </div>

          {value?.orderUnit && (
            <FormControl
              type="number"
              placeholder="Anzahl der Bestelleinheiten des Naturalrabatts"
              min={1}
              max={256}
              value={value?.count || ""}
              onChange={e =>
                onChange({
                  ...value,
                  count: e.target.valueAsNumber || 0,
                })
              }
            />
          )}
          {error && <HelpBlock>{error.message}</HelpBlock>}
          {showDeleteConfirmation && (
            <ConfirmDeletion
              onClickNo={() => setShowDeleteConfirmation(false)}
              onClickYes={removeProduct}
            />
          )}
        </FormGroup>
      </div>
    );
  },
);
